<mat-nav-list id="sidenav-list">
  @for (link of links; track link) {
    <app-sidenav-list-item
      [link]="link"
      (logout)="handleLogout()"
      (linkClick)="handleLinkClick($event)"
    ></app-sidenav-list-item>
  }
</mat-nav-list>
